import { alpha } from "@mui/material/styles";

export const Pink = "#df156c";
export const Coral = "#f04b4b";
export const Purple = "#351b6f";
export const Mauve = "#dbd8e8";
export const White = "#ffffff";

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

const PRIMARY = {
  // lighter: '#D1E9FC',
  // light: '#76B0F1',
  main: Pink,
  // dark: '#103996',
  // darker: '#061B64',
  contrastText: "#fff",
};

const SECONDARY = {
  // lighter: "#D6E4FF",
  // light: "#84A9FF",
  main: Coral,
  // dark: "#1939B7",
  // darker: "#091A7A",
  contrastText: "#fff",
};

const INFO = {
  // lighter: "#D0F2FF",
  light: "#64B6F7",
  main: "#2196F3",
  dark: "#0B79D0",
  // darker: "#04297A",
  contrastText: "#fff",
};

const SUCCESS = {
  // lighter: "#E9FCD4",
  light: "#43C6B7",
  main: "#14B8A6",
  dark: "#0E8074",
  // darker: "#08660D",
  contrastText: GREY[0],
};

const WARNING = {
  // lighter: "#FFF7CD",
  light: "#FFBF4C",
  main: "#FFB020",
  dark: "#B27B16",
  // darker: "#7A4F01",
  contrastText: GREY[0],
};

const ERROR = {
  // lighter: "#FFE7D9",
  light: "#DA6868",
  main: "#D14343",
  dark: "#922E2E",
  // darker: "#7A0C2E",
  contrastText: "#fff",
};

const palette = {
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  neutral: GREY,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  common: {
    black: "#000",
    white: "#fff",
    purple: Purple,
    mauve: Mauve,
  },
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: "#fff",
    default: GREY[0],
    neutral: GREY[200],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
